import { IconButton, Stack, Tooltip } from "@mui/material";
import React, { useState } from "react";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import ImageRatioSelector from "components/images/ImageRatioSelector";
import ImageTransparencySelector from "../ImageTransparencySelector";
import ImageUploaderIconButton from "../ImageUploaderIconButton";
import { useDispatch, useSelector } from "react-redux";
import { imageStudioActions } from "../../../store/imageStudio";
import ClearPromptButton from "../ClearPromptButton";

export default function ImageGeneratorToolbar() {
  const dispatch = useDispatch();
  const imageStudioState = useSelector((state) => state.imageStudio);

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack direction="row" spacing={1}>
        <ImageUploaderIconButton
          addImage={(image) => dispatch(imageStudioActions.addImage(image))}
          numImages={imageStudioState.images.length}
        />
        {imageStudioState.model?.ratio && (
          <ImageRatioSelector
            ratio={imageStudioState.ratio}
            setRatio={(ratio) =>
              dispatch(imageStudioActions.setImageRatio(ratio))
            }
          />
        )}
        {imageStudioState.model?.transparency && (
          <ImageTransparencySelector
            transparent={imageStudioState.transparent}
            setTransparent={(transparent) =>
              dispatch(imageStudioActions.setTransparent(transparent))
            }
          />
        )}
      </Stack>
      <Stack direction="row" spacing={1}>
        <ClearPromptButton />
      </Stack>
    </Stack>
  );
}
